import React, { useState } from "react";
import styled from "styled-components";
import emailjs from 'emailjs-com';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Logo } from "../logo";
import { Marginer } from "../marginer";
import { faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import './footer.css';

const FooterContainer = styled.div`
  width: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1f1f1f;
  position: relative;
`;

const MotivationalText = styled.h1`
  font-size: 25px;
  font-weight: 500;
  line-height: 1.4;
  color: #fff;
  margin: 0;
`;

const AccessibilityContainer = styled.div`
  width: 80%;
  display: flex;
  border-top: 1px solid #cdcdcd;
  padding-top: 12px;
  padding-right: 10px;
  padding-left: 10px;
  color: #fff;
  justify-content: space-between;

  @media screen and (max-width: 480px) {
    width: 90%;
    padding-left: 8px;
    padding-right: 8px;
  }
`;

const PrivacyContainer = styled.div`
  display: flex;
`;

const SocialContainer = styled.div`
  display: flex;
`;

const SocialIcon = styled.div`
  color: #fff;
  font-size: 20px;
  transition: all 200ms ease-in-out;
  cursor: pointer;

  &:not(:last-of-type) {
    margin-right: 11px;

    @media screen and (max-width: 480px) {
      margin-right: 9px;
    }
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }

  &:hover {
    color: #adadad;
  }
`;

const Link = styled.a`
  color: #fff;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  font-size: 14px;

  &:not(:last-of-type) {
    margin-right: 11px;

    @media screen and (max-width: 480px) {
      margin-right: 9px;
    }
  }

  @media screen and (max-width: 480px) {
    font-size: 12px;
  }

  &:hover {
    color: #adadad;
  }
`;

const RightsReserved = styled.div`
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 12px;
`;

export function Footer(props) {
  
  const initialState = {
    name: '',
    email: '',
    message: ''
};

const [data, setData] = useState(initialState);

const handleChange = (e) => {

    const { name, value } = e.target;

    setData((preVal) => {
        return {
            ...preVal,
            [name]: value
        }
    });
};

const onSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_pio69qs', 'techxsols', ".contact-form", 'user_MfYyNfpOfO8UiqosPOQZ2')
    .then((result) => {
        // M.toast({html: 'Thanks! Your email has been received', classes:"toast"})
    }, (error) => {
        console.log(error.text);
    });
    setData(initialState);
}

  return (
    <FooterContainer name="contactForm">
      <Marginer direction="vertical" margin="5em" />
      <Logo small />
      <Marginer direction="vertical" margin="1em" />
      <MotivationalText>Just say the magical word</MotivationalText>
      <MotivationalText>and we will do the rest</MotivationalText>
      <Marginer direction="vertical" margin="1em" />
      <div className="contactUs">
            <h1 className="text-center my-5">Contact Us</h1>
            <div className="container container_div my-5">
                <div className="row">
                    <div className="col-md-6 col-10 mx-auto">
                        <form onSubmit={onSubmit} className="contact-form">
                            <div className="mb-3">
                                <label htmlFor="name">Name</label>
                                <input required type="text" className="form-control" name="name" value={data.name} onChange={handleChange} id="name" placeholder="Enter name here..." />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email">Email address</label>
                                <input required type="email" className="form-control" name="email" value={data.email} onChange={handleChange} id="email" placeholder="Enter email here..." />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message">Your Message</label>
                                <textarea required className="form-control" name="message" value={data.message} onChange={handleChange} id="message" rows="3"></textarea>
                            </div>
                            <div className="mb-3">
                                <button className="btn btn-outline-primary" type="submit">Submit form</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      <Marginer direction="vertical" margin="5em" />
      <AccessibilityContainer>
        <PrivacyContainer>
          <Link>Privacy Policy</Link>
          <Link>Terms of Service</Link>
          <Link>Contact</Link>
        </PrivacyContainer>
        <SocialContainer>
          <SocialIcon>
            <FontAwesomeIcon icon={faTwitter} />
          </SocialIcon>
          <SocialIcon>
            <FontAwesomeIcon icon={faLinkedin} />
          </SocialIcon>
        </SocialContainer>
      </AccessibilityContainer>
      <RightsReserved>&copy; 2020 TechDev All rights reserved</RightsReserved>
    </FooterContainer>
  );
}
